import "./SelectPage.scss"
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {useLocation, useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";
import Logo from "../../Atoms/Logos/Logo";
import styled from "styled-components";
import GreenBtnB from "../../Atoms/Buttons/RedBtnB";
import WhiteBtnB from "../../Atoms/Buttons/WhiteBtnB";
import PoorRtan from "../../Atoms/Rtans/PoorRtan";
import GiftCard from "../../Atoms/Cards/GiftCard";
import YellowBtnRS from "../../Atoms/Buttons/YellowBtnRS";
import Modal from "../../Atoms/Modals/Modal";
import {useEffect, useState} from "react";
import modalImg from "./giftmodal.png"
import {sendCPLog} from "../../../Utils/Log/CPlog"
import CardRtan from "../../Atoms/Rtans/CardRtan";
import Web from "../../Atoms/Course/Web";
import Sql from "../../Atoms/Course/Sql";
import SpartaIcon from "../../Atoms/Rtans/SpartaIcon";
import FirstGift from "../../Atoms/Gifts/FirstGift";
import ThirdGift from "../../Atoms/Gifts/ThirdGift";
import SecondGift from "../../Atoms/Gifts/SecondGift";
import {config} from "../../../config";

const ResultTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 16px 119px;
  gap: 16px;

  width: 375px;
  height: 57px;
`

const ResultTitle = styled.div`

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 6px;

  width: 118px;
  height: 25px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;

  text-align: center;
  color: #141617;

`

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px 23px 50px;
  gap: 32px;

  background: #F6F9FA;
`

const ResultText = styled.div`
  ont-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  text-align: center;

  color: #141617;
`

const ResultContent = styled.div`

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;

  text-align: center;
  white-space: pre-wrap;
  align-items: flex-start;

  color: #141617;
`

const NbGiftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  gap: 16px;

  width: 328px;
  height: 212px;

  /* Gray/White [day] */

  background: #FFFFFF;
  border-radius: 12px;
`

const NbGiftWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  gap: 16px;

  width: 328px;
  height: 233px;

  /* Gray/White [day] */

  background: #FFFFFF;
  border-radius: 12px;
`


const NbGiftWrapper3 = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  gap: 16px;

  width: 328px;
  height: 234px;


  background: #FFFFFF;
  border-radius: 12px;
`

const NbGiftTitleWrap1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  white-space: pre-wrap;
  align-items: flex-start;

  width: 226px;
  height: 28px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;

  text-align: center;


  color: #141617;
`

const NbGiftTitleWrap2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 266px;
  height: 49px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;

  text-align: center;
  color: #141617;

  span {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    text-align: left;
    color: #81898F;

  }
`

const NbGiftTitleWrap3 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;


  width: 278px;
  height: 50px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;
  color: #141617;
`


const NbGiftIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 10px;
  gap: 10px;

  height: 28px;
  background: #FFF1F4;
  border-radius: 17px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 150%;
  text-align: center;


  color: #e8344e;
`

const NbGiftIcon2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 10px;
  gap: 10px;

  width: 54px;
  height: 28px;

  background: #DFEDE4;
  border-radius: 17px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 150%;
  text-align: center;


  color: #0F572C;
`

const NbGiftIcon3 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 10px;
  gap: 10px;

  width: 54px;
  height: 28px;

  background: #DFEDE4;
  border-radius: 17px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 150%;
  text-align: center;
  color: #0F572C;
`

const NbGiftText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  text-align: left;
  gap: 6px;
`


const NbGift = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;

  width: 314px;
  height: 250px;
`

const Header = styled.div`
`

const Notice = styled.div`
  font-family: 'Pretendard';
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  text-align: center;
  color: #5F666B;
`;

const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-item: center;
  gap: 16px;
`


export default () => {
  const {state} = useLocation();
  const logObj = state?.logObj;
  const navigate = useNavigate();
  const [cookie, setCookie, removeCookie] = useCookies([]);
  const [modalVisible, setModalVisible] = useState(0);
  const [modalVisible2, setModalVisible2] = useState(0);
  const user = cookie.userinfo;
  const login = () => {
    const nextUrl = `${config.online.url}/mypage/mycoupon?coupon_code=spcsdc&from=quiz`;
    window.open(`${config.online.url}/login?next=${encodeURIComponent(nextUrl)}`);
  }
  useEffect(() => {
    sendCPLog("nb_cardquiz_response", logObj);
  }, [])
  useEffect(
    () => {
      if (typeof logObj === 'undefined' || Object.keys(logObj).length === 0) {
        navigate("/nb/selection")
      }
    }, [])

  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(() => setModalVisible([1, 0][modalVisible]), 2000)
      return () => clearTimeout(timer)
    }
  })

  const toggleModal = () => {
    sendCPLog("nb_cardquiz_click_button", {
      "button_text": "테스트 공유하기",
      "result": "yes"
    })
    setModalVisible([1, 0][modalVisible]);
  }
  const toggleModal2 = () => setModalVisible2([1, 0][modalVisible2]);

  return (
    <Wrapper>
      <Header>
        <ResultTitleWrap>
          <ResultTitle>
            대상자 조회결과
          </ResultTitle>
        </ResultTitleWrap>
      </Header>
      <ResultWrapper>
        <ResultText>
          앗! 카드 발급 대상자가 아니예요
        </ResultText>
        <SpartaIcon></SpartaIcon>
        <ResultContent>
          {`하지만 스파르타가 \n더 큰 선물을 준비했어요!`}
        </ResultContent>

        <NbGiftWrapper>
          <NbGiftTitleWrap1>
            <NbGiftIcon>
              선물 1
            </NbGiftIcon>
            10만원 할인 쿠폰 제공
          </NbGiftTitleWrap1>
          <NbGift>
            <FirstGift/>
          </NbGift>
        </NbGiftWrapper>

        <NbGiftWrapper3>
          <NbGiftTitleWrap3>
            <NbGiftIcon>
              선물 2
            </NbGiftIcon>
            <NbGiftText>
              직장인 필수! <br/>
              코딩 용어 해설 강의 무료 지급
            </NbGiftText>
          </NbGiftTitleWrap3>
          <NbGift>
            <ThirdGift></ThirdGift>
          </NbGift>
        </NbGiftWrapper3>
        <Notice>
          쿠폰과 포인트는 스파르타코딩클럽 온라인<br/>
          강의 결제 시 사용할 수 있어요.
        </Notice>

          <BtnContainer className="btn-container">
            <GreenBtnB
              onClick={() => {
                login();
              }}
            >
              지금 선물 받기
            </GreenBtnB>
            <CopyToClipboard text={"https://nbquiz.spartacodingclub.kr/nb"} onCopy={toggleModal}>
              <WhiteBtnB>
                테스트 공유하기
              </WhiteBtnB>
            </CopyToClipboard>
          </BtnContainer>
      </ResultWrapper>
      <Modal toggle={toggleModal} open={modalVisible}>
        <ResultModal>
          링크가 복사되었습니다.
        </ResultModal>
      </Modal>
    </Wrapper>
  )
}


const Wrapper = styled.div`
`

const ResultModal = styled.div`
  height: 100px;
  width: 320px;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.04px;
  text-align: center;
  color: #000;
`
